/**
 * Собирает view model рейса внутри заказа, не изменяя исходный API-объект.
 * Используется экраном заказа; raw-статус остаётся доступен для последующей
 * отправки изменения на backend.
 */
/** Возвращает копию рейса с раздельными кодом и пользовательской подписью статуса. */
export function buildOrderTripViewModel(trip, formatStatus) {
  return {
    ...trip,
    statusCode: trip.status,
    statusLabel: formatStatus(trip.status),
  };
}
